export const CHAIN_NAMESPACES = {
    EIP155: "eip155",
};
const getChainConfig = (hexChainId) => {
    if (hexChainId === "0x1") {
        return {
            chainNamespace: CHAIN_NAMESPACES.EIP155,
            chainId: "0x1", // eth mainnet
        };
    }
    if (hexChainId === "0x5") {
        return {
            chainNamespace: CHAIN_NAMESPACES.EIP155,
            chainId: "0x5", // goerli testnet
        };
    }
    if (hexChainId === "0x89") {
        return {
            chainNamespace: CHAIN_NAMESPACES.EIP155,
            chainId: "0x89", // polygon 137
        };
    }
    throw Error("Invalid chainId");
};
export const checkChainId = (chainId) => {
    try {
        getChainConfig(chainId);
        return true;
    }
    catch (error) {
        return false;
    }
};
export const defaultChainConfigs = [
    getChainConfig("0x1"),
    getChainConfig("0x5"),
    getChainConfig("0x89"),
];
//# sourceMappingURL=config.js.map